import { render, staticRenderFns } from "./MasterUsulan.vue?vue&type=template&id=297db95e&"
import script from "./MasterUsulan.vue?vue&type=script&lang=js&"
export * from "./MasterUsulan.vue?vue&type=script&lang=js&"
import style0 from "./MasterUsulan.vue?vue&type=style&index=0&id=297db95e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports